import { render, staticRenderFns } from "./fileUpload.vue?vue&type=template&id=28819a2d&scoped=true"
import script from "./fileUpload.vue?vue&type=script&lang=js"
export * from "./fileUpload.vue?vue&type=script&lang=js"
import style0 from "./fileUpload.vue?vue&type=style&index=0&id=28819a2d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28819a2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28819a2d')) {
      api.createRecord('28819a2d', component.options)
    } else {
      api.reload('28819a2d', component.options)
    }
    module.hot.accept("./fileUpload.vue?vue&type=template&id=28819a2d&scoped=true", function () {
      api.rerender('28819a2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fileUpload.vue"
export default component.exports